// ----------------------------------------------------------------------
// Global Dashboard Translations - Portuguese
// ----------------------------------------------------------------------

export const globalDashboardPt = {
  global_dashboard: {
    // Page title
    page_title: 'Painel de Controle',

    // Welcome messages by role
    welcome: {
      owner: 'Gerencie seu negócio aqui',
      ambassador: 'Pronto para promover eventos incríveis?',
      referral: 'Descubra novos eventos para compartilhar e ganhar',
      waiter: 'Vamos gerenciar essas mesas com eficiência',
      default: 'Seu painel está pronto',
    },

    // Contextual info alerts
    context_info: {
      event_mode_title: 'Foco em Gestão de Eventos',
      event_mode_description: 'Você está no modo de gestão de eventos. Mude para o modo restaurante ou estúdio de música nas configurações, se necessário.',
      restaurant_mode_title: 'Foco em Gestão de Restaurante',
      restaurant_mode_description: 'Você está no modo de gestão de restaurante. Mude para o modo eventos ou estúdio de música nas configurações, se necessário.',
      music_studio_mode_title: 'Foco em Gestão de Estúdio de Música',
      music_studio_mode_description: 'Você está no modo de gestão de estúdio de música. Mude para o modo eventos ou restaurante nas configurações, se necessário.',
    },

    // Dashboard modules
    modules: {
      events_management: 'Gestão de Eventos',
      events_description: 'Crie, gerencie e acompanhe seus eventos',
      organizations: 'Organizações',
      organizations_description: 'Gerencie suas organizações e configurações',
      restaurants: 'Restaurantes',
      restaurants_description: 'Gerencie restaurantes e menus',
      music_studios: 'Estúdios de Música',
      music_studios_description: 'Gerencie estúdios de gravação, reservas e sessões',
      network_team: 'Rede & Equipe',
      network_team_description: 'Convide usuários, gerencie equipe e acompanhe referências',
      ambassador_events: 'Eventos de Embaixador',
      ambassador_events_description: 'Visualize e promova eventos como embaixador',
      my_events: 'Meus Eventos',
      my_events_description: 'Acompanhe seus eventos promovidos e ganhos',
      table_management: 'Gestão de Mesas',
      table_management_description: 'Gerencie mesas de restaurante e pedidos',
    },

    // Quick actions
    quick_actions: {
      title: 'Ações Rápidas',
      create_event: 'Criar Evento',
      create_organization: 'Criar Organização',
      invite_team: 'Convidar Equipe',
      search_events: 'Pesquisar Eventos',
    },

    // Available modules section
    available_modules: 'Módulos Disponíveis',

    // Buttons
    buttons: {
      open: 'Abrir',
      manage: 'Gerenciar',
      copy_link: 'Copiar Link',
      share: 'Compartilhar',
      create_event: 'Criar Evento',
      create_event_org: 'Criar Org. de Evento',
      create_studio: 'Criar Estúdio',
    },

    // Labels
    labels: {
      new: 'Novo',
      event_org: 'Org. Evento',
      studio: 'Estúdio',
    },

    // Enhanced events module
    events_module: {
      title: 'Gestão de Eventos',
      recent_events: 'eventos recentes',
      click_to_manage: 'Clique para gerenciar todos',
      no_recent_events: 'Sem eventos recentes',
      click_to_create: 'Clique para criar seu primeiro evento',
      create_first_event: 'Crie seu primeiro evento para começar',
      more_events: 'mais eventos',
    },

    // Event organizations module
    event_orgs_module: {
      title: 'Organizações de Eventos',
      recent_organizations: 'organizações recentes',
      no_organizations: 'Ainda não há organizações de eventos',
      create_first_org: 'Crie sua primeira organização de eventos',
      followers: 'seguidores',
    },

    // Music studios module
    music_studios_module: {
      title: 'Estúdios de Música',
      recent_studios: 'estúdios recentes',
      no_studios: 'Ainda não há estúdios de música',
      create_first_studio: 'Crie seu primeiro estúdio de música',
      services: 'serviços',
    },

    // Invitation card
    invitation_card: {
      title: 'Convidar para a Rede',
      description: 'Compartilhe seu link de convite',
      your_link: 'Seu link de convite:',
      link_copied: 'Link de convite copiado para a área de transferência!',
      link_copy_failed: 'Falha ao copiar o link',
      share_title: 'Junte-se à Minha Rede',
      share_text: 'Junte-se à minha rede e descubra eventos incríveis!',
    },

    // Contacts card
    contacts_card: {
      title: 'Meus Contatos',
      description: 'Gerencie seus contatos',
      access_list: 'Acesse sua lista de contatos',
      add_new: 'Adicionar novos contatos',
      send_messages: 'Enviar e-mails e mensagens',
    },

    // Event status chips
    event_status: {
      upcoming: 'próximo',
      ongoing: 'em andamento',
      past: 'passado',
    },

    // Mode chips
    mode: {
      event: 'Modo Evento',
      music_studio: 'Modo Estúdio de Música',
      restaurant: 'Modo Restaurante',
    },

    // Footer
    footer: {
      help_text: 'Precisa de ajuda? Consulte nossa documentação ou entre em contato com o suporte.',
    },
  },
};

export default globalDashboardPt;
